const menuScreenshotModules = import.meta.glob("../../assets/images/landing/free-menu-setup/*.{png,jpg,jpeg,webp}", {
  eager: true,
  import: "default",
}) as Record<string, string>

export const menuScreenshots = Object.entries(menuScreenshotModules)
  .sort(([firstPath], [secondPath]) => firstPath.localeCompare(secondPath))
  .map(([path, src]) => ({
    alt:
      path
        .split("/")
        .pop()
        ?.replace(/\.[^/.]+$/, "")
        .replace(/[-_]/g, " ") || "Cardápio digital pronto",
    src,
  }))
